// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"b679c726","280":"93dead3d","494":"e532c8e6"}[chunkId] + ".chunk.js";
};